import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import { cropClasses, EditIcon } from "../../utility";
import { useState } from "react";

const BucketActionColumn = ({ bucket, currDarkThemeClass, onEdit, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    onEdit(bucket);
    handleClose();
  };

  const handleDelete = () => {
    onDelete(bucket);
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick} size="small">
        <MoreVertIcon sx={{color: "whitesmoke"}} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          className: currDarkThemeClass,
        }}
      >
        <MenuItem onClick={handleEdit} className={`${cropClasses?.menuItem} ${currDarkThemeClass}`}>
          <EditIcon sx={{ mr: 1, fontSize: '1rem' }} />
          Edit
        </MenuItem>
        <MenuItem onClick={handleDelete} className={`${cropClasses?.menuItem} ${currDarkThemeClass}`}>
          <DeleteIcon sx={{ mr: 1, fontSize: '1rem', color:"#B1D23A" }}  />
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

export default BucketActionColumn;